import {UI} from "../../../../../../stem-core/src/ui/UIBase.js";
import {StyleSheet} from "../../../../../../stem-core/src/ui/Style.js";

import {BlinkInput, BlinkInputStyle} from "../../../../../ui/Input.jsx";
import {Messages} from "../../../../../Messages.js";
import {AmazonPayLogo, AmExIcon, MasterCardIcon, VisaIcon} from "../../../../../../core/ui/SVGElements.jsx";
import {styleRule, styleRuleInherit} from "../../../../../../stem-core/src/decorators/Style.js";
import {
    StripeCardInput,
    StripeCardInputStyle
} from "../../../../../website/authenticated/pages/wallet/components/cards/StripeCardInput.jsx";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme.js";
import {NOOP_FUNCTION} from "../../../../../Utils.js";
import {isFirefox} from "../../../../../Utils.js";
import {isSmallScreen} from "../../../../../UtilsLib.js";
import {iFrameMerchantService} from "blinkpay/services/IframeMerchantService.js";
import {BlinkCardInput} from "../../../../../website/authenticated/pages/wallet/components/cards/BlinkCardInput.jsx";
import {Controller} from "../../../../flows/Controller.js";
import {Button} from "../../../../../../stem-core/src/ui/button/Button.jsx";
import {AmazonPayWidget} from "../../../../../website/authenticated/pages/wallet/components/cards/AmazonPayWidget.jsx";
import {PayPalWidget} from "../../../../../website/authenticated/pages/wallet/components/cards/PayPalWidget.jsx";
import {LinkButton} from "../../../../../../core/ui/LinkButton.jsx";
import {PaymentProcessorStore, PaymentProcessorType} from "../../../../../../client/state/PaymentProcessorStore.js";
import {Theme} from "../../../../../../stem-core/src/ui/style/Theme.js";
import {PaymentMethodStore} from "../../../../../../client/state/PaymentMethodStore.js";


class InlineErrorStripeCardInputStyle extends StripeCardInputStyle {
    @styleRuleInherit
    errorMessage = {
        position: "absolute",
        top: -6,
        paddingBottom: 0,
        left: 0,
        transform: "translateY(calc(-100%))",
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_SMALL,
        marginTop: 0,
    };
}

class CardFormStyle extends StyleSheet {
    @styleRule
    cardIcons = {
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: 10,
    };

    @styleRule
    cardIcon = {
        marginLeft: 8,
    };
}

export class NameInputStyle extends BlinkInputStyle {
    @styleRuleInherit
    input = {
        "-webkit-text-stroke-width": isSmallScreen() ? 0 : ".2px",
        fontSize: () => this.themeProps.MERCHANT_FONT_SIZE_LARGE + " !important",
        "::placeholder": {
            textShadow: (isFirefox() ? "0px" : "0.2px") + `0px 0px ${this.themeProps.MERCHANT_INPUT_PLACEHOLDER_COLOR}`,
            opacity: 1,
        },
        ...this.themeProps.MERCHANT_INPUT_CONTAINER,
    };
}

@registerStyle(NameInputStyle)
export class NameInput extends BlinkInput {}

@registerStyle(CardFormStyle)
export class CardForm extends UI.Element {
    getDefaultOptions() {
        return {
            onChange: NOOP_FUNCTION,
        }
    }

    updateAltPayData(provider, orderId) {
        Controller.paymentMethod.setAltPayOrderId(provider, orderId);
        this.options.onChange(); // This will redraw the parent component. TODO @cleanup bad pattern
    }

    getAltPaySection() {
        const amazonPaymentProcessor = PaymentProcessorStore.findBy({
            merchantId: iFrameMerchantService.merchantId,
            provider: PaymentProcessorType.AMAZON,
        });

        const paypalPaymentProcessor = PaymentProcessorStore.findBy({
            merchantId: iFrameMerchantService.merchantId,
            provider: PaymentProcessorType.PAYPAL,
        });

        let altPayButtons = [];

        if (amazonPaymentProcessor) {
            const useAmazonPay = () => AmazonPayWidget.requestWidgetInSDK(amazonPaymentProcessor, (amazonPayOrderId) => {
                this.updateAltPayData(PaymentProcessorType.AMAZON, amazonPayOrderId);
            });

            altPayButtons.push(
                <Button
                    style={{
                        width: "100%",
                        maxWidth: 350,
                        margin: "auto",
                        padding: 9,
                        borderRadius: 4,
                        borderColor: "black",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={useAmazonPay}>
                    <AmazonPayLogo style={{display: "inline-block", lineHeight: 0, marginTop: 2}}/>
                </Button>
            );
        }

        if (paypalPaymentProcessor) {
            const onApprove = (data) => {
                this.updateAltPayData(PaymentProcessorType.PAYPAL, data.billingToken);
            }

            altPayButtons.push(<PayPalWidget
                paymentProcessor={paypalPaymentProcessor}
                onApprove={onApprove}
                style={{width: "100%", maxWidth: 368, margin: "auto", paddingTop: 8}}
            />);
        }

        if (altPayButtons.length === 0) {
            return null;
        }

        return <div>
            <div style={{textAlign: "center"}}>
                {altPayButtons}
            </div>
            <div style={{textAlign: "center", paddingTop: 12}}>
                Or enter your card details below
            </div>
        </div>
    }

    render() {
        const {styleSheet} = this;
        const creditCardIconSize = 12;

        const CardInputClass = iFrameMerchantService.isCDSPaymentMethod() ? BlinkCardInput : StripeCardInput;
        Theme.register(StripeCardInput, InlineErrorStripeCardInputStyle); // TODO A bit of a hack

        const {altPayData} = Controller.paymentMethod;

        return altPayData ?
            <div>
                You have selected {altPayData.provider.toString()} for this payment.
                <LinkButton
                    style={{marginTop: 8, display: "flex", textAlign: "center"}}
                    onClick={() => this.updateAltPayData(null)}
                    label="Use another payment method?"
                />
            </div> : [
                this.getAltPaySection(),

                <NameInput
                    ref="nameInput"
                    inputAttributes={{
                        placeholder: Messages.addCardNameInput.toString(),
                        autofocus: true
                    }}
                    initialValue={Controller.paymentMethod?.cardHolderName}
                    validators={[{
                        condition: () => !this.nameInput.isEmpty()
                    }]}
                    onBlur={() => this.nameInput.validate()}
                    onChange={() => this.options.onChange()}
                />,
                <div className={styleSheet.cardIcons}>
                    <VisaIcon size={creditCardIconSize} className={styleSheet.cardIcon}/>
                    <MasterCardIcon size={creditCardIconSize} className={styleSheet.cardIcon}/>
                    <AmExIcon size={creditCardIconSize} className={styleSheet.cardIcon}/>
                </div>,
                <CardInputClass
                    ref="cardInput"
                    autofocus={false}
                    onChange={() => this.options.onChange()}
                />,
            ]
    }

    isValid() {
        if (Controller.paymentMethod.altPayData) {
            return true;
        }
        return this.cardInput?.isInputComplete() && this.nameInput?.isValid();
    }

    getExtraCardData() {
        let result = {};
        if (this.nameInput) {
            result.name = this.nameInput.getValue();
            Controller.paymentMethod.cardHolderName = result.name;
        }
        return result;
    }

    async confirmCard(scope = PaymentMethodStore.Scope.PUBLIC) {
        if (this.cardInput) {
            return this.cardInput.confirmCard(scope, this.getExtraCardData());
        }

        // We're using an alt pay
        // TODO @mustfix investigate
        return {};
    }
}
